export function createSingleFlight(requestFactory) {
  let pendingRequest = null

  return (...args) => {
    if (!pendingRequest) {
      pendingRequest = Promise.resolve()
        .then(() => requestFactory(...args))
        .finally(() => {
          pendingRequest = null
        })
    }

    return pendingRequest
  }
}

export function createKeyedSingleFlight(requestFactory, keyResolver = () => '') {
  const pendingRequests = new Map()

  return (...args) => {
    const key = String(keyResolver(...args) ?? '')
    if (!pendingRequests.has(key)) {
      const pendingRequest = Promise.resolve()
        .then(() => requestFactory(...args))
        .finally(() => {
          if (pendingRequests.get(key) === pendingRequest) {
            pendingRequests.delete(key)
          }
        })
      pendingRequests.set(key, pendingRequest)
    }

    return pendingRequests.get(key)
  }
}
